import ArrowRightIcon from '@/common/assets/icons/arrowRightIcon.svg?react';
import EstelamIcon from '@/common/assets/icons/estelamIcon.svg?react';
import { InquiryPlateType } from '@/common/components/base/inquiryPlate/inquiryPlate.type';
import InquiryWithPlateModal from '@/common/components/base/inquiryPlate/modals/InquiryWithPlateModal';
import Typography from '@/common/components/base/typography/Typography';
import useModal from '@/common/hooks/useModal';
import { css } from 'styled-system/css';
import { Box, Flex } from 'styled-system/jsx';
import { token } from 'styled-system/tokens';

const InquiryPlate = ({ fileId, fetchedResultHandler }: InquiryPlateType) => {
  const { closeModal, open, openModal } = useModal();
  return (
    <Flex
      dir="row"
      gap={'17px'}
      justify="space-between"
      align="center"
      bg={'white'}
      p={'16px'}
      borderRadius={'8px'}
      shadow={'0px 0px 10px 0px rgba(0, 0, 0, 0.10)'}
    >
      <Box flexBasis={'20%'}>
        <EstelamIcon className={css({ width: '100%', height: '100%' })} />
      </Box>
      <Box
        display={'flex'}
        justifyContent={'center'}
        flexDirection={'column'}
        alignItems={'center'}
        flexBasis={'80%'}
        gap={'10px'}
      >
        <Typography textStyle={'h2'}>استعلام با پلاک خودرو</Typography>
        <Typography textStyle={'b4'} color={'black-4'}>
          استعلام بر اساس پلاک و کدملی مالک خودرو
        </Typography>
        <Typography
          onClick={() => openModal()}
          cursor={'pointer'}
          display={'flex'}
          alignItems={'center'}
          gap={'2px'}
        >
          <Typography textStyle={'b4'} color={'purple-2'}>
            استعلام{' '}
          </Typography>
          <ArrowRightIcon
            className={css({
              position: 'relative',
              top: '2px',
              height: '8px',
              width: '8px',
              strokeWidth: '20px',
            })}
            stroke={token('colors.purple-2')}
          />
        </Typography>
      </Box>
      <InquiryWithPlateModal
        fileId={fileId}
        closeModal={closeModal}
        open={open}
        fetchedResultHandler={fetchedResultHandler!}
      />
    </Flex>
  );
};

export default InquiryPlate;
